import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import * as Models from '../../models/commonModels';
import { EnvironmentService } from '../../../app/services/environment.service';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public download(Document: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/document/download`, Document, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }
}


